import React, { useEffect, useState } from 'react';
import { Form, Input, Select } from 'antd';

const { Option } = Select;

const CArticuloCosmeticoEmpresa = () => {
  const [auxiliares, setAuxiliares] = useState({ tipos_piel: [], usos: [], generos: [] });

  useEffect(() => {
    const fetchAuxiliares = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/cosmetico/auxiliares`);
        const data = await res.json();
        setAuxiliares(data);
      } catch (error) {
        console.error('Error al cargar auxiliares de cosmético:', error);
      }
    };

    fetchAuxiliares();
  }, []);

  return (
    <>
      <Form.Item name="fragancia" label="Fragancia">
        <Input />
      </Form.Item>

      <Form.Item name="contenido_neto" label="Contenido Neto">
        <Input />
      </Form.Item>

      <Form.Item name="tipo_piel" label="Tipo de Piel">
        <Select placeholder="Seleccione un tipo de piel">
          {auxiliares.tipos_piel.map(t => (
            <Option key={t.tip_id} value={t.tip_nombre}>{t.tip_nombre}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="uso" label="Uso (diurno, nocturno, etc.)">
        <Select placeholder="Seleccione el uso">
          {auxiliares.usos.map(u => (
            <Option key={u.uso_id} value={u.uso_nombre}>{u.uso_nombre}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="genero" label="Género">
        <Select placeholder="Seleccione un género">
          {auxiliares.generos.map(g => (
            <Option key={g.gen_id} value={g.gen_nombre}>{g.gen_nombre}</Option>
          ))}
        </Select>
      </Form.Item>
    </>
  );
};

export default CArticuloCosmeticoEmpresa;